"use client";

import {Sidebar} from "@/lib/interfaces/pages";
import Link from "next/link";
import BulbIcon from "@/components/icons/BulbIcon";
import Image from "next/image";

interface SidebarItemProps {
    children: React.ReactNode
    title: string
}

function SidebarSection({children, title}: SidebarItemProps) {
    return (
        <section className={`eo-section`}>
           <div className="eo-sectionTitle m-small">
                <h2 className="title">{title}</h2>
                <div className="icon m-icon">
                    <BulbIcon/>
                </div>
            </div>
            {children}
        </section>
    )
}

type SidebarType = {
    sidebar: Sidebar
}

export default function Sidebar({ sidebar }: SidebarType) {
    const sections = sidebar.blocks.map(section => {
        const linklist = section.children.map(list => {
            const items = list.children.map(item => {
                return (
                    <Link href={item.content.link_url} className="linkList-item" key={item.id}>
                        {list.content.layout == "list_with_images" &&
                        <span className="icon m-image">
                           {item.medias[0]
                            ?<Image width={150} height={75} src={`${item.medias[0].original}`} alt="image text"/>
                            :<Image width={150} height={75} src="" alt="image text"/>
                            }
                        </span>
                        }
                        <span className="label">{item.content.link_title}</span>
                    </Link>
                )
            })
            return (
                <div className="eo-linkList-wrap" key={list.id}>
                {list.content.layout == "basic"
                ?<div className="eo-linkList m-buttons">
                    <div className="linkList-title">{list.content.title}</div>
                    <div className="linkList-items">
                        {items}
                    </div>
                </div>
                :<div className="eo-linkList m-list m-largeIcons">
                    <div className="linkList-title">{list.content.title}</div>
                    <div className="linkList-items">
                        {items}
                    </div>
                </div>
                }
            </div>

            )
        })
        return (
            <SidebarSection title={section.content.title} key={section.id}>
                {linklist}
            </SidebarSection>
        )
    })

    return sections

}